/* EBONFORM — saving a work opens the saved list.
   Tapping a heart that is not yet saved saves it, then the saved works slide in.
   Tapping a saved heart again only removes it, quietly. */
(() => {
  document.addEventListener('click', (event) => {
    const heart = event.target.closest && event.target.closest('.ewl-card, .ewl-save');
    if (!heart) return;
    /* capture phase: this runs before the wishlist script toggles the heart */
    if (heart.classList.contains('is-on')) return;
    setTimeout(() => {
      if (window.EbonformWishlist && typeof window.EbonformWishlist.open === 'function') {
        window.EbonformWishlist.open();
      }
    }, 260);
  }, true);
})();
